export default __webpack_public_path__ + "static/media/2.cb120b5f.jpg";